<template>
  <div class="child mt-5 pl-auto ml-auto mr-auto pr-auto" style="width: 100% !important;background-color: #F5F5F5" :style="{ filter: getBright }" v-if="languageData.labels">
    <v-row class="mt-3" no-gutters>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
        <v-text-field
            class="ml-5"
            v-model="value.number"
            :label="'No'"
            hide-details
            disabled
        ></v-text-field>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ?  9 : 12">
        <v-text-field
            class="ml-5"
            v-model="value.name"
            :label="languageData.calculationLabels.name"
            :placeholder="languageData.calculationLabels.name"
            hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="1" v-if="level !== 0" class="mt-3">
        <v-btn
          v-if="level !== 0 && value.visibleInput === true"
          color="fontDefault"
          @click="$emit('delete')"
        >
          <v-icon style="color: white !important;">
            mdi-trash-can
          </v-icon>
        </v-btn>
      </v-col>
      <v-row v-if="value.type === 'position'" class="mt-3">
        <v-col cols="12" class="text-left ml-3">
          <v-btn
                color="primary"
                class="mr-5"
                :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
                @click="openWorkCostsTableModal"
            >
            {{ languageData.calculationLabels.workCostsBtn }}
            </v-btn>
            <v-btn
                color="primary"
                class="mr-5"
                :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
                @click="openMaterialCostsTableModal"
            >
            {{ languageData.calculationLabels.materialCostsBtn }}
            </v-btn>
            <v-btn
                color="primary"
                class="mr-5"
                :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
                @click="openDriveCostsTableModal"
            >
            {{ languageData.calculationLabels.driveCostsBtn }}
            </v-btn>
        </v-col>
      </v-row>
      <v-col cols="12">
        <div class="children-wrapper" v-if="value.children.length">    
              <Instance
                v-for="(instance, key) in value.children"
                v-model="value.children[key]"
                :key="instance.id"
                :level="level + 1"
                :id="instance.id"
                @delete="showDeleteModal(instance)"
                :disabled="level < 1"
            ></Instance>
        </div>
      </v-col>
      <v-col cols="12" class="text-left ml-3" :class="(value.visibleInput === true && level === 0) || value.visibleInput === false ? 'mt-5 mb-3' : null">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                color="primary"
                v-if="(value.visibleInput === true && level === 0) || value.visibleInput === false"
                @click="addChild(value.id)"
                class="mr-5"
                :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ languageData.calculationLabels.addPosition }}
          </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                outlined
                color="primary"
                @click="addSubcategory(value.id)"
                v-if="(value.visibleInput === true && level === 0) || value.visibleInput === false"
                class="mr-5"
                :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ languageData.calculationLabels.addSubcategory }}
          </span>
        </v-tooltip>
        <v-btn
          v-if="!value.visibleInput && !isLevelZero"
          color="fontDefault"
          class="mr-5"
          @click="$emit('delete')"
          :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
        >
          <v-icon style="color: white !important;">
            mdi-trash-can
          </v-icon>
        </v-btn>
        <v-btn
            color="fontDefault"
            class="mr-5"
            @click="showDeleteParentModal(value)"
            v-if="level === 0"
            :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
        >
          <v-icon style="color: white !important;">
            mdi-trash-can
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="value.type === 'position'">
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12" style="display: flex; align-items: center;">
        <p class="mt-3 ml-6" style="font-size: 18px">{{ languageData.calculationLabels.billingFor }}</p>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
        <v-text-field
            class="ml-5"
            :label="languageData.calculationLabels.quantity"
            v-model.number="value.quantity"
            type="number"
            step="0.001"
            :placeholder="languageData.calculationLabels.quantity"
        ></v-text-field>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
        <v-select
            :label="languageData.calculationLabels.uom"
            v-model="value.uom"
            :items="measureTypesEnum"
            :placeholder="languageData.calculationLabels.uom"
            class="ml-5"
            item-value="value"
            item-text="name"
            required
            return-object>
          <template slot='selection' slot-scope='{ item }'>
            {{ languageData.measureTypes[item.value] }}
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ languageData.measureTypes[item.value] }}
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row v-if="value.type === 'position'">
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 1 : 12" style="display: flex; align-items: center;">
        <p class="mt-3 ml-6" style="font-size: 18px">{{ languageData.calculationLabels.sum }}</p>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
        <v-text-field
            class="ml-5"
            :label="languageData.calculationLabels.totalCost"
            v-model.number="value.total_cost"
            type="number"
            :placeholder="languageData.calculationLabels.totalCost"
            disabled
        ></v-text-field>
      </v-col>   
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 1 : 12" style="display: flex; align-items: center;">
        <p class="mt-3 ml-6" style="font-size: 18px">{{ languageData.calculationLabels.for }}</p>
      </v-col>  
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
        <v-text-field
            :label="languageData.calculationLabels.quantity"
            v-model.number="value.quantity"
            class="ml-5"
            type="number"
            step="0.001"
            :suffix="value.uom && typeof value.uom === 'object' ? languageData.measureTypes[value.uom.value] : value.uom && typeof value.uom !== 'object' ? languageData.measureTypes[value.uom] : null"
            disabled
        >
        </v-text-field>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1" class="text-center">
        <v-icon
            style="line-height: 2.5 !important;">mdi-equal</v-icon>
      </v-col>     
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
        <v-text-field
            class="ml-5"
            :label="(value.total_cost && value.uom) || value.total_cost ? null : languageData.calculationLabels.totalPerUom"
            v-model.number="value.total_cost_per_quantity"
            type="number"
            disabled
            :suffix="value.total_cost && value.uom.value && value.total_cost_per_quantity ? 'euro/' + 1 + languageData.measureTypes[value.uom.value] : null"
            :placeholder="(value.total_cost && value.uom) || value.total_cost ? null : languageData.calculationLabels.totalPerUom"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <ModalInfo @doOperation="deleteChild(instanceToDelete)" :typeInfo="'success'" :headModal="languageData.modalSuccess.head" :btnDisAgreeText="languageData.btnDisAgreeText" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDeleteInfo" :show-modal="isShowDeleteModalInfo" :text-modal="languageData.modalSuccess.text + instanceToDelete.name + '?'"></ModalInfo>
    <ModalInfo @doOperation="deleteParent()" :typeInfo="'success'" :headModal="languageData.modalSuccess.head" :btnDisAgreeText="languageData.btnDisAgreeText" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDeleteParentInfo" :show-modal="isShowDeleteParentModalInfo" :text-modal="languageData.modalSuccess.text + parentToDelete.name + '?'"></ModalInfo>
    <ModalInfo layout="modalSelectTable"  v-if="isShowWorkCostsTableModal" :hidden-agree-btn="true" @clicked="hideWorkCostsTableModal" :show-modal="isShowWorkCostsTableModal">
      <template v-slot:body>
        <WorkCostsTable :workCostsData="value.costs.workCosts" :workCostsDeleted="value.costs.workCostsDeleted" :calculationItemId="value.id"></WorkCostsTable>
      </template>
    </ModalInfo>
    <ModalInfo layout="modalSelectTable" v-if="isShowMaterialCostsTableModal" :hidden-agree-btn="true" @clicked="hideMaterialCostsTableModal" :show-modal="isShowMaterialCostsTableModal">
      <template v-slot:body>
        <MaterialCostsTable :materialCostsData="value.costs.materialCosts" :materialCostsDeleted="value.costs.materialCostsDeleted"  :calculationItemId="value.id"></MaterialCostsTable>
      </template>
    </ModalInfo>
    <ModalInfo layout="modalSelectTable" v-if="isShowDriveCostsTableModal" :hidden-agree-btn="true" @clicked="hideDriveCostsTableModal" :show-modal="isShowDriveCostsTableModal">
      <template v-slot:body>
        <DriveCostsTable :driveCostsData="value.costs.driveCosts" :driveCostsDeleted="value.costs.driveCostsDeleted" :calculationItemId="value.id"></DriveCostsTable>
      </template>
    </ModalInfo>
  </div>
</template>

<style src="./Instance.scss" lang="scss"></style>

<script type="text/javascript">
  import {Child} from "../../helpers/child";
  import {mapActions} from "vuex";
  import Instance from "./Instance";
  import eventBus from "../../../../event-bus/eventBus";
  import measureTypesEnum from "../../../../enums/measureTypes";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo.vue";
  import WorkCostsTable from "../WorkCosts/WorkCostsTable/WorkCostsTable.vue";
  import MaterialCostsTable from "../MaterialCosts/MateralCostsTable/MaterialCostsTable.vue";
  import DriveCostsTable from "../DriveCosts/DriveCostsTable/DriveCostsTable.vue";

  export default {
    name: "Instance",
    props: {
      level: Number,
      value: Object,
      id: Number,
    },
    components: {
      Instance,
      ModalInfo,
      WorkCostsTable,
      MaterialCostsTable,
      DriveCostsTable
    },
    data() {
      return {
        model: {
          children: []
        },
        isShowDeleteModalInfo: false,
        isShowDeleteParentModalInfo: false,
        modalDeleteInfoData: {
          typeInfo: "",
          head: "",
          textInfo: ""
        },
        instanceToDelete: {},
        parentToDelete: {},
        categoryToDelete: {},
        measureTypesEnum: measureTypesEnum,
        totalPriceRow: 0,
        modalDeleteData: {
          idData: 0,
          languageData: {}
        },
        maxPercent: 100,
        minPercent: 1,
        isShowWorkCostsTableModal: false,
        isShowMaterialCostsTableModal: false,
        isShowDriveCostsTableModal: false,
      }
    },
    watch: {
      'value': {
        deep: true,
        handler: function(newValue) {
            if (newValue.type === 'position' && newValue.costs) {
                newValue.total_cost = this.calculateTotalCost(newValue.costs);
            }
            if (newValue.type === 'position' && newValue.total_cost && newValue.quantity) {
                newValue.total_cost_per_quantity = this.calculateTotalCostPerQuantity();
            }
        }
      },
    },
    methods: {
      ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),

      calculateTotalCost(costs) {
        const workCosts = costs.workCosts.map( el => Number(el.total) ).reduce( (a, b) => a + b, 0 );
        const materialCosts = costs.materialCosts.map( el => Number(el.total) ).reduce( (a, b) => a + b, 0 );
        const driveCosts = costs.driveCosts.map( el => Number(el.total )).reduce( (a, b) => a + b, 0 );
        return (workCosts + materialCosts + driveCosts).toFixed(2);
      },

      calculateTotalCostPerQuantity() {
        return (Number(this.value.total_cost )/ Number(this.value.quantity)).toFixed(2);
      },

      openWorkCostsTableModal() {
        this.isShowWorkCostsTableModal = true;
      },

      hideWorkCostsTableModal() {
        this.isShowWorkCostsTableModal = false;
      },

      openMaterialCostsTableModal() {
        this.isShowMaterialCostsTableModal = true;
      },

      hideMaterialCostsTableModal() {
        this.isShowMaterialCostsTableModal = false;
      },

      openDriveCostsTableModal() {
        this.isShowDriveCostsTableModal = true;
      },

      hideDriveCostsTableModal() {
        this.isShowDriveCostsTableModal = false;
      },

      addChild: function(id) {
        this.value.children.push(new Child(id, true, 'position'));
        eventBus.$emit('refreshCalculationNumbers');
      },
      addSubcategory (id) {
        this.value.children.push(new Child(id, false, 'category'));
        eventBus.$emit('refreshCalculationNumbers');
      },
      showDeleteModal: function(instance) {
        this.instanceToDelete = instance;
        this.isShowDeleteModalInfo = true;
      },
      hideModalDeleteInfo: function() {
        this.isShowDeleteModalInfo = false;
      },
      showDeleteParentModal: function(parent) {
        this.parentToDelete = parent;
        this.isShowDeleteParentModalInfo = true;
      },
      hideModalDeleteParentInfo: function() {
        this.isShowDeleteParentModalInfo = false;
      },
      deleteChild: function(child) {
        this.value.children.splice(this.value.children.indexOf(child), 1);
        if(this.value.children.length === 0) {
          this.value.visibleInput = false;
        }
        if(child.visibleInput === true) {
          eventBus.$emit("deleteItem", child.id);
        } else {
          eventBus.$emit("deleteCategory", child.id);
        }
      },
      deleteParent() {
        eventBus.$emit("deleteParent", this.parentToDelete);
      },
      updateNumbersEmit() {
        eventBus.$emit('updateNumbers');
      },
    },
    computed: {
      getBright: function() {
        let brightPercentage = 100 - 2 * this.level;
        return 'brightness(' + brightPercentage + '%)';
      },
      isLevelZero: function() {
        return this.level === 0;
      },
    },
    mounted() {
    },
  }
</script>